import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useRouteTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
      console.log("✅ GA4 page_view sent:", location.pathname + location.search);
    } else {
      console.warn("⚠️ gtag not defined yet.");
    }
  }, [location]);
};

export default useRouteTracking;
